import { SettingOutlined } from '@ant-design/icons'
import { Program as ProgramModel } from '@models/membership/Program'
import { useAppSelector } from '@store/hooks'
import { selectPlansByIds } from '@store/membership/PlanReducer'
import { selectProgramById } from '@store/membership/ProgramReducer'
import { SBModelComponent } from '@supplement-bacon/react-toolkit/models'
import { Button, Card, Descriptions, Flex, List, Typography } from 'antd'
import { FC } from 'react'
import { Link } from 'react-router-dom'
import Program from './Program'

const { Text, Title } = Typography
type Props = SBModelComponent<ProgramModel> & {}

const ProgramCard: FC<Props> = ({ id, model }) => {
  const item = model ? model : useAppSelector(selectProgramById(id!))
  const plans = useAppSelector(selectPlansByIds(item?.plans ?? []))

  if (!item) {
    return <></>
  }

  return (
    <Card>
      <Flex vertical gap={16}>
        <Flex justify="space-between" align="center" className="mb-4">
          <Title level={5} className="m-0">
            {item.friendlyName}
          </Title>
          <Program.PasscodeTag model={item} />
        </Flex>
        <Card styles={{ body: { padding: 0 } }}>
          <List
            dataSource={plans.map((plan) => ({
              name: plan.en.name,
              price: plan.en.description1,
            }))}
            renderItem={(item) => (
              <List.Item>
                <Flex
                  justify="space-between"
                  className="w-full"
                  style={{ paddingLeft: 10, paddingRight: 10 }}
                >
                  <Text>{item.name}</Text>{' '}
                  <Text type="secondary">{item.price}</Text>
                </Flex>
              </List.Item>
            )}
          />
        </Card>
        <Descriptions column={1}>
          <Descriptions.Item label="Registration url">
            <Text copyable>{item.frontendUrl}</Text>
          </Descriptions.Item>
        </Descriptions>
        <Link to={`/settings/membership/programs/${item.slug}/informations`}>
          <Button type="primary" block icon={<SettingOutlined />}>
            Manage
          </Button>
        </Link>
      </Flex>
    </Card>
  )
}

type ProgramCardType = { Card: typeof ProgramCard }

export { ProgramCard, type ProgramCardType }
